import {
	SelectionGroup,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { Component } from '@angular/core';
import { MatterActions } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { InterestOptions } from '@models/matter';
import { TestHooks } from './interest-estate.hooks';
import { dispatch, select } from '@ngxs/store';

@Component({
	selector: 'app-interest-estate',
	templateUrl: './interest-estate.component.html',
	standalone: false,
})
export class InterestEstateComponent {
	testHooks = TestHooks;
	interestEstate_ = select(SelectedMatter.interestEstate);
	OverwriteFields = dispatch(MatterActions.OverwriteFields);
	public interestEstateOptions: SelectionGroup[] = [
		{
			items: [
				{ name: InterestOptions.FEES },
				{ name: InterestOptions.LHOLD },
				{ name: InterestOptions.EASE },
				{ name: InterestOptions.FEEAS },
				{ name: InterestOptions.SURFRT },
				{ name: InterestOptions.MINERT },
				{ name: InterestOptions.LIFERE },
				{ name: InterestOptions.OTHER },
			],
		},
	];

	setInterestEstate(value: DropdownResult<{ name: string }>) {
		this.OverwriteFields({
			field: 'propertyDetails.interestEstate',
			value: value?.result?.name,
		});
	}
}
